import { Button, Section, Text } from '@ui';
import { useTranslation } from 'react-i18next';
import { useInstall } from './install';

/** Settings → Über swarm: install the app, or how to do it on this device. */
export function InstallSection() {
  const { t } = useTranslation();
  const install = useInstall();
  if (install.kind === 'unavailable') return null;
  return (
    <Section variant="content" title={t('pwa.title')}>
      {install.kind === 'installed' && <Text tone="muted">{t('pwa.installed')}</Text>}
      {install.kind === 'ios' && <Text>{t('pwa.iosSteps')}</Text>}
      {install.kind === 'prompt' && (
        <Button variant="secondary" onClick={() => void install.install()}>
          {t('pwa.install')}
        </Button>
      )}
    </Section>
  );
}
